<div>
  <section id="ProgessIndicatorContainer">
    <ds-progress-indicator
      progressTitle="Claim Progress"
      [steps]="progressData.claimSteps"
    ></ds-progress-indicator>
  </section>
  @if (progressData.claimProgress === 'SUBMISSION' || progressData.claimProgress === 'EVALUATION') {
    <div class="pad-top-20">
      <b><p dsContent [contentPath]="'claims.evaluateProgressBarHeaderText'"></p></b>
      <ol class="pad-left-40">
        <li dsContent [contentPath]="'claims.evaluateProgressBarListItemText1'"></li>
        <li dsContent [contentPath]="'claims.evaluateProgressBarListItemText2'"></li>
        <li dsContent [contentPath]="'claims.evaluateProgressBarListItemText3'"></li>
        <li dsContent [contentPath]="'claims.evaluateProgressBarListItemText4'"></li>
      </ol>
    </div>
  }
  @if (progressData.claimProgress === 'RESOLUTION') {
    <div class="pad-top-20">
      <p dsContent [contentPath]="'claims.resolveProgressBarHeaderText'"></p>
      <ol class="pad-left-40">
        <li
          dsContent
          [contentPath]="
            claimType === 'AUTO'
              ? 'claims.resolveProgressBarListItemText1Auto'
              : 'claims.resolveProgressBarListItemText1Property'
          "
        ></li>
        <li
          dsContent
          [contentPath]="
            claimType === 'AUTO'
              ? 'claims.resolveProgressBarListItemText2Auto'
              : 'claims.resolveProgressBarListItemText2Property'
          "
        ></li>
        <li
          dsContent
          [contentPath]="
            claimType === 'AUTO'
              ? 'claims.resolveProgressBarListItemText3Auto'
              : 'claims.resolveProgressBarListItemText3Property'
          "
        ></li>
      </ol>
    </div>
  }
</div>
